import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Flex,
  useDisclosure,
  useToast,
  IconButton,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";

import { ViewIcon } from "@chakra-ui/icons";

import axiosClient from "../../../api/axiosClient";
import CategoryDetailDialog from "./components/CategoryDetailDialog";

export default function DynamicTable({ columnsData, endpoint }) {
  const cardBg = useColorModeValue("white", "navy.700");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const headerColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const tableColor = useColorModeValue("gray.700", "gray.300");

  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);

  const [selectedRow, setSelectedRow] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const loadData = async () => {
    try {
      const res = await axiosClient.get(`${endpoint}?page=${page}`);
      setData(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch (error) {
      toast({
        title: "Gagal memuat data",
        description: error.response?.data?.message || "Terjadi kesalahan",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    loadData();
  }, [page]);

  return (
    <Box
      bg={cardBg}
      borderRadius="16px"
      boxShadow="0 4px 12px rgba(0,0,0,0.1)"
      p="24px"
      w="100%"
    >
      <Box w="100%" overflowX="auto">
        <Table
          variant="simple"
          color={tableColor}
          mb="24px"
          w="100%"
          sx={{ tableLayout: "fixed" }}
        >
          <Thead>
            <Tr>
                      {columnsData.map((col, i) => (
                            <Th key={i} color={headerColor} borderColor={borderColor}>
                              {col.Header}</Th>
                      ))}
              <Th color={headerColor} borderColor={borderColor}>
                Actions
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {data.map((row, i) => (
              <Tr key={row.id || i}>
                {columnsData.map((col, j) => (
                  <Td key={j} color={textColor} borderColor={borderColor}>
                    {col.accessor === "__index"
                      ? (page - 1) * (meta?.per_page ?? data.length) + i + 1
                      : col.Cell
                      ? col.Cell(row[col.accessor], row)
                      : row[col.accessor]}
                  </Td>
                ))}

                <Td color={textColor} borderColor={borderColor}>
                  <Flex gap="10px">
                    <Tooltip label="Detail" hasArrow>
                      <IconButton
                        icon={<ViewIcon />}
                        size="sm"
                        colorScheme="blue"
                        aria-label="Detail"
                        onClick={() => {
                          setSelectedRow(row);
                          onOpen();
                        }}
                      />
                    </Tooltip>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Flex mt="20px" justifyContent="center" alignItems="center" gap="10px">
        <Button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          isDisabled={page === 1}
        >
          Prev
        </Button>

        <Box mt="8px" color={textColor}>
          Page {page} / {meta?.total_pages ?? 1}
        </Box>

        <Button
          onClick={() => setPage((p) => p + 1)}
          isDisabled={meta?.total_pages === page}
        >
          Next
        </Button>
      </Flex>

      <CategoryDetailDialog
        isOpen={isOpen}
        onClose={onClose}
        data={selectedRow}
      />
    </Box>
  );
}